<template>
    <div></div>
</template>

<script>


export default {
  name: 'HomeViewSide',
  components: {
  },
}
</script>

<style>
</style>
